import { render, staticRenderFns } from "./warningMakesure.vue?vue&type=template&id=ceee41c4&scoped=true&"
import script from "./warningMakesure.vue?vue&type=script&lang=js&"
export * from "./warningMakesure.vue?vue&type=script&lang=js&"
import style0 from "./warningMakesure.vue?vue&type=style&index=0&id=ceee41c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceee41c4",
  null
  
)

export default component.exports